import { call, put, race, select, takeLatest } from "redux-saga/effects";
import { getFlow, getFlowStart } from "../selectors/flow";
import { endFlow } from "../actions/flow";
import { setCertificationTestAsViewed } from "../services/certificationTestExecutionService";
import { requestMergeCertificationTestResult } from "../actionCreators/certificationTestResult";
import { CHECK_CERTIFICATION_TEST_RESULT_FLOW } from "../consts";
import { logError } from "../util";

export default function* () {
  yield takeLatest(getFlowStart(CHECK_CERTIFICATION_TEST_RESULT_FLOW), function* () {
    yield race({
      call: call(function* () {
        try {
          const flow = yield select(getFlow(CHECK_CERTIFICATION_TEST_RESULT_FLOW));

          const certificationTestResult = yield call(setCertificationTestAsViewed, {
            certificationTest: flow.params.certificationTest,
          });
          yield put(requestMergeCertificationTestResult(certificationTestResult));
        } catch (error) {
          logError({ error, flow: CHECK_CERTIFICATION_TEST_RESULT_FLOW });
          // yield put(startFlow(HANDLE_ERROR_FLOW, {
          //   error: 'error_save_answer',
          //   retryFlow: {
          //     id: SAVE_PRACTICE_TEST_ITEM_EXECUTION_ANSWER_FLOW,
          //   }
          // }));
        } finally {
          yield put(endFlow(CHECK_CERTIFICATION_TEST_RESULT_FLOW));
        }
      }),
    });
  });
}
